export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Final2_07.fb5233cb.jpg";